import { Component, OnInit, Input, ChangeDetectionStrategy, HostListener, ElementRef, ViewChild } from '@angular/core';
import { DynamicSearchFormService } from './dynamic-search-form.service';
import { Observable, fromEvent, of, BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, tap, debounceTime } from 'rxjs/operators';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Moment } from 'moment';
import * as moment from 'moment';

@Component({
	selector: 'm-dynamic-search-form',
	templateUrl: './dynamic-search-form.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
//#region Quy định type:
//0: input text
//1: select
//2: m-dropdown-tree
//3: checkbox
//4: datetime đơn
//5: Khoảng thời gian
//Đối với loại 1,2 cần truyền api để tải dữ liệu xổ xuống
//#endregion
export class DynamicSearchFormComponent implements OnInit {
	constructor(public dynamicSearchFormService: DynamicSearchFormService,
		private fb: FormBuilder) { }

	formSearch: FormGroup;
	@ViewChild('searchbox', { static: true }) searchbox: ElementRef;
	@ViewChild('searchForm', { static: true }) searchForm: ElementRef;
	@ViewChild('container', { static: true }) container: ElementRef;
	showSearch: boolean = false;
	@Input() isNV: boolean = false;
	@Input() keyword: string = "";
	controls: any[] = [];

	ngOnInit(): void {
		this.controls = this.dynamicSearchFormService.controls$.getValue();
		for (var i = 0; i < this.controls.length; i++) {
			if (this.controls[i].search) {
				let index = i;
				this.dynamicSearchFormService.getInitDataSearch(this.controls[i].api).then(res => {
					if (this.controls[index].type == 2) {
						this.controls[index].init = new BehaviorSubject([]);
						this.controls[index].init.next(res.data);
					}
					else
						this.controls[index].init = res.data;
				});
			} else {
				if (this.controls[i].api) {
					let index = i;
					this.dynamicSearchFormService.getInitData(this.controls[i].api).subscribe(res => {
						if (this.controls[index].type == 2) {
							this.controls[index].init = new BehaviorSubject([]);
							this.controls[index].init.next(res.data);
						}
						else
							this.controls[index].init = res.data;
					});
				}
			}
		}
		this.createForm();
		fromEvent(this.searchbox.nativeElement, 'keyup')
			.pipe(
				debounceTime(150),
				distinctUntilChanged(),
				tap(() => {
					let kw = this.searchbox.nativeElement.value;
					if (this.dynamicSearchFormService.searchbox && this.formSearch.controls[this.dynamicSearchFormService.searchbox])
						this.formSearch.controls[this.dynamicSearchFormService.searchbox].setValue(kw);
				})
			)
			.subscribe();

		document.querySelector('body').appendChild(this.container.nativeElement);
	}
	ngOnDestroy() {
		document.querySelector('body').removeChild(this.container.nativeElement);
	}


	createForm() {
		let item = {};
		for (var i = 0; i < this.controls.length; i++) {
			let control = this.controls[i];
			if (control.type != 5) {
				if (control.type == 3)
					item[control.name] = [false];
				else
					item[control.name] = [''];
			} else {
				item[control.from.name] = [''];
				item[control.to.name] = [''];
			}
		}
		this.formSearch = this.fb.group(item);
	}

	//Xử lý nút X để xóa form+textbox search
	clearSearch() {
		this.showSearch = false;
		this.createForm();
		this.keyword = '';
		// this.searchbox.nativeElement.value = '';
		this.dynamicSearchFormService.setFilter({}, this.isNV);
	}

	//Xử lý hiển thị form search
	showFormSearch() {
		this.showSearch = true;
		let temp = this.searchbox.nativeElement.getBoundingClientRect();
		this.searchForm.nativeElement.style.top = temp.bottom + 'px';
		this.searchForm.nativeElement.style.left = temp.left + 'px';
		this.searchForm.nativeElement.style.width = temp.width + 'px';
	}

	//Xử lý dữ liệu trên form để trả về
	submit() {
		let str = '';
		const controls = this.formSearch.controls;
		const item = {};
		for (var i = 0; i < this.controls.length; i++) {
			if (this.controls[i].type == 5) {
				let from = this.controls[i].from.name;
				if (controls[from].value) {
					if (str != '')
						str += ';';
					let d1 = moment(controls[from].value).format('DD/MM/YYYY');
					item[from] = d1;
					str += from + ':' + d1;
				}
				let to = this.controls[i].to.name;
				if (controls[to].value) {
					if (str != '')
						str += ';';
					let d2 = moment(controls[to].value).format('DD/MM/YYYY');
					item[to] = d2;
					str += to + ':' + d2
				}
			}
			else {
				let name = this.controls[i].name;
				if (controls[name].value || this.controls[i].type == 3) {
					if (str != '')
						str += ';';
					if (this.controls[i].type == 4) {
						let d = moment(controls[name].value).format('DD/MM/YYYY');
						item[name] = d;
						str += name + ':' + d
					} else {
						item[name] = controls[name].value;
						str += name + ':' + controls[name].value
					}
				}
			}
		}
		this.dynamicSearchFormService.setFilter(item, this.isNV);
		this.showSearch = false;
		this.keyword = str;
		// this.searchbox.nativeElement.value = str;
	}

	//bắt sự kiện click ngoài form search thì đóng form
	@HostListener('document:click', ['$event'])
	clickout(event) {
		if (event.target.id == 'id-form-filter-container')
			this.showSearch = false;
	}

	//Bắt sự kiện enter trên text box để trả về
	onKeydownHandler() {
		let kw = this.searchbox.nativeElement.value;
		const filter: any = {};
		filter[this.dynamicSearchFormService.searchbox] = kw;
		this.dynamicSearchFormService.setFilter(filter, this.isNV);
	}

	//đến ngày luôn lấy min là từ ngày
	DateChangeMin(val: any, index) {
		let mindate = val.value.toDate();
		this.controls[index].to.min = mindate;
	}

	//từ ngày luôn lấy max là đến ngày
	DateChangemMax(val: any, index) {
		let maxdate_cur = val.value.toDate();
		this.controls[index].from.max = maxdate_cur;
	}
}
